
define('text!TescoMobile_Checkout/template/limit-modal.html',[],function () { return '<div class="limit-modal"> <%= data.content %> </div>';});

